export const MIN_SEARCH_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 300;

export const toServerSearch = (value: string): string => {
	const trimmed = value.trim();
	return trimmed.length >= MIN_SEARCH_LENGTH ? trimmed : '';
};
